module.exports = __webpack_public_path__ + "static/media/aspas-quote.7669c431.svg";